import { getStoreGeoLocation, setGeoLocation } from "../Cookies";

export const getGeoLocation = () => {
  return new Promise((resolve, reject) => {
    const storedGeolocation = getStoreGeoLocation();
    if (storedGeolocation?.latitude && storedGeolocation?.longitude) {
      resolve(storedGeolocation);
      return;
    }
    if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      setGeoLocation(position.coords.latitude, position.coords.longitude);
      resolve(position)
    }, () =>{ 
      resolve(null)
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    });
    } else {
    reject(null)
    return 
    }
  })
}